/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Weather_Snow_ModerateInputs */

const en_ui_weather_snow_moderate = /** @type {(inputs: Ui_Weather_Snow_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Moderate snowfall`)
};

const de_ui_weather_snow_moderate = /** @type {(inputs: Ui_Weather_Snow_ModerateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mäßiger Schneefall`)
};

/**
* | output |
* | --- |
* | "Moderate snowfall" |
*
* @param {Ui_Weather_Snow_ModerateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_weather_snow_moderate = /** @type {((inputs?: Ui_Weather_Snow_ModerateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Weather_Snow_ModerateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_weather_snow_moderate(inputs)
	return de_ui_weather_snow_moderate(inputs)
});